import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FuseNavigationService } from './navigation.service';
import { Subscription } from 'rxjs/Subscription';
import { FuseNavigationModel } from '../../../main/navigation/navigation.model';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { ContactDialogComponent } from '../../../main/contact-dialog/contact-dialog.component';
import { Cliente } from '../../modelos/cliente';
import { ClientesService } from '../../../main/content/clientes/clientes.service';
import { NotificacionesService } from '../../notificaciones/notificaciones.service';
import { ToolbarService } from '../../../main/toolbar/toolbar.service';
import { ClientesComponent } from '../../../main/content/clientes/clientes.component';
import { FileManagerService } from '../../../main/content/file-manager/file-manager.service';
import { Router } from '@angular/router';
import { User } from '../../modelos/user';

@Component({
  selector: "fuse-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class FuseNavigationComponent implements OnDestroy {
  navigationModel: any;
  navigationModelApps: any;
  navigationModelManage: any;
  navigationModelChangeSubscription: Subscription;
  contactDialogRef: MatDialogRef<ContactDialogComponent>;
  esAdmin = false;
  clienteSeleccionado: Cliente;
  clientes: Array<Cliente>;
  usuario: User;

  @Input("layout") layout = "vertical";
  foto = "assets/images/logos/bimux.png";
  logo = "assets/images/logos/bod.png";

  constructor(
    private fuseNavigationService: FuseNavigationService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private clientesService: ClientesService,
    private notificaciones: NotificacionesService,
    private toolbarService: ToolbarService,
    private fileManager: FileManagerService,
    private router: Router,
  ) {

    this.navigationModelChangeSubscription = this.fuseNavigationService.onNavigationModelChange.subscribe(
      (navigationModel) => {
        this.navigationModel = navigationModel;
        this.navigationModelApps = Array.isArray(navigationModel)
          ? navigationModel.filter((a) => a.id === "applications")
          : navigationModel;
        this.navigationModelManage = Array.isArray(navigationModel)
          ? navigationModel.filter((a) => a.id === "gestion")
          : navigationModel;
      }
    );

    // Si estoy logueado y he refrescado tengo que cargar el menu de nuevo
    if (sessionStorage.getItem("usuarioLogueado")) {
      // const usuario: User = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
      // if (usuario.rol.id !== 1 && usuario.cliente && usuario.cliente.logo) {
      //     this.foto = 'data:image/jpeg;base64,' + usuario.cliente.logo;
      // } else {
      //     this.foto = 'assets/images/logos/bimux.png';
      // }
      /* try {
                this.foto = 'data:image/jpeg;base64,' + usuario.cliente.logo;
            } catch (error) {
                this.foto = 'assets/images/pngLogoBODblancoygris/Sin_simbolo_blanco.png';
            } */
      // Set the navigation model
      this.fuseNavigationService.setNavigationModel(
        new FuseNavigationModel(translate)
      );

      this.usuario = JSON.parse(
        sessionStorage.getItem("usuarioLogueado")
      ).usuario;
      if (this.usuario.rol.id === 1) {
        this.esAdmin = true;
      }
    }

    if (this.esAdmin) {
        this.getClientes();
    }
  }

  ngOnDestroy() {
    this.navigationModelChangeSubscription.unsubscribe();
  }

  openContactForm() {
    this.contactDialogRef = this.dialog.open(ContactDialogComponent, {
      width: "400px",
      data: {
        id: "",
        descripcion: "",
        valor: "",
        clave: 1,
        activo_id: "",
      },
    });
  }

  compare(val1, val2) {
    if (val1 && val2) {
      return val1.id === val2.id;
    }
  }

  setCliente(cliente: Cliente) {

        // this.clienteSeleccionado = cliente;
        this.toolbarService.setClienteAdmin(cliente);
        ClientesComponent.cambiarCliente(cliente);
        this.fileManager.setClienteBucket(cliente);
        this.router.navigate(['/portfolio']);

    }

  setClienteAdmin(cliente: Cliente) {
    this.clientesService.adminCambiarCliente(cliente.id).subscribe(
      (data) => {
        if (data.success) {
          this.setCliente(cliente);
          sessionStorage.setItem(
            "usuarioLogueado",
            JSON.stringify({ usuario: data.items })
          );
        } else {
          this.notificaciones.mostrarAviso(
            this.notificaciones.mensajes.IdiomaActual.Clientes.SinClientes
          );
        }
      },
      (err) => {
        this.notificaciones.errorServidor(err.status);
      }
    );
  }

  getClientes() {
    this.clientesService.getClientes().subscribe(
        data => {
            if (data.success) {
                this.clientes = data.items;

                if (this.usuario.cliente) {
                    this.clienteSeleccionado = this.usuario.cliente;
                } else {
                    this.getClienteAdmin();
                }



            } else {
                this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Clientes.SinClientes);
            }
        },
        err => {
            this.notificaciones.errorServidor(err.status);
        }
    );
  }

  getClienteAdmin() {
        this.toolbarService.getClienteAdmin().subscribe(
            data => this.clienteSeleccionado = data
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/navigation/navigation.component.ts